import { FloatingWindow, FloatingWindowType } from 'types/app.types';

const defaultFloatingWindowsList: FloatingWindow[] = [
  {
    index: '1',
    title: 'Weather products',
    top: 10,
    left: 10,
    type: FloatingWindowType.Products,
  },
  {
    index: '2',
    title: 'Alarms',
    top: 10,
    left: 440,
    type: FloatingWindowType.Alarms,
  },
];

export default defaultFloatingWindowsList;
